import { goBack } from "~/shared_states/modal";
import { ButtonRegular } from "~/widgets/button";

export function HowToTransferModal() {
  return (
    <div class="relative flex h-full w-full flex-col items-center justify-start bg-baseTertiaryLight px-5 py-4">
      <div class="h-1 w-[45px] rounded-[22px] bg-baseTertiaryDark" />
      <h1 class="mb-4 mt-6 text-h4 text-textDark">
        How to transfer incentive to your bank account
      </h1>
      <div class="mb-5 flex w-full flex-col items-start justify-start gap-2">
        <div class="flex items-center justify-start gap-2">
          <div class="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-baseTertiaryMedium text-[10px] font-bold text-textDark">
            1
          </div>
          <p class="text-medium text-textDark">
            Enter the amount you want to transfer
          </p>
        </div>
        <div class="flex items-center justify-start gap-2">
          <div class="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-baseTertiaryMedium text-[10px] font-bold text-textDark">
            2
          </div>
          <p class="text-medium text-textDark">
            Select a mode of transfer- UPI or Net banking
          </p>
        </div>
        <div class="flex items-center justify-start gap-2">
          <div class="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-baseTertiaryMedium text-[10px] font-bold text-textDark">
            3
          </div>
          <p class="text-medium text-textDark">Receive money in your account</p>
        </div>
      </div>
      <ButtonRegular class="w-full" isEnabled={true} onClick={() => goBack()}>
        Got it
      </ButtonRegular>
    </div>
  );
}
